import React from "react";
import { Box, Column, Columns, Stack } from "@origin-digital/ods-core";
import type { OtherCategoriesProps } from "./types";
import { ICategoryDto } from "../../contract";
import { OtherCategoryCard } from "./OtherCategoryCard";

export const OtherCategories: React.FC<OtherCategoriesProps> = ({
  categories,
}) => {
  if (categories.length === 0) return null;

  // First 2 render as a 2-column row; the rest as a 3-column row
  const wideRow = categories.slice(0, 2);
  const narrowRow = categories.slice(2);

  const renderRow = (items: ICategoryDto[], isWide?: boolean) => (
    <Columns
      space={{ xs: "medium", lg: "large" }}
      collapseBelow="lg"
      alignY="stretch"
    >
      {items.map((category) => (
        <Column key={category.id} alignSelf="stretch">
          <OtherCategoryCard category={category} isWide={isWide} />
        </Column>
      ))}
    </Columns>
  );

  return (
    <Box data-id="other-categories" marginX={{ xs: "medium", sm: "none" }}>
      <Stack space={{ xs: "medium", lg: "large" }}>
        {wideRow.length > 0 && renderRow(wideRow, true)}
        {narrowRow.length > 0 && renderRow(narrowRow)}
      </Stack>
    </Box>
  );
};
